import {
  Card,
  Row,
  Col,
  Typography,
  Badge,
  Descriptions,
  Progress,
  Space,
  Alert,
  Divider,
  Popover,
  Tag,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { networkColorList } from "../../helpers/network.color";

const labelColor = {
  color: "grey",
};

export function SubgraphStatus({ title, themeColor, textColor, indexingStatus }: any) {
  const chain = indexingStatus?.chains.length > 0 ? indexingStatus.chains[0] : null;
  const latestBlock = chain.latestBlock?.number;
  const earliestBlock = chain.earliestBlock?.number;
  const chainHeadBlock = chain.chainHeadBlock?.number;

  const networkColor = networkColorList[chain?.network] ? networkColorList[chain?.network] : "grey";

  return (
    <Card
      className="card-body"
      title={
        <>
          {title}{" "}
          <Popover
            placement="right"
            content={
              <Space style={{ width: 400 }}>
                Note: Graph Node will mark the newly deployed version as the Pending Version, sync
                it in the background, and only replace the currently deployed version with the new
                one once syncing the new version has finished
              </Space>
            }
            trigger="hover"
          >
            <InfoCircleOutlined />
          </Popover>
        </>
      }
      extra={
        earliestBlock >= 0 && latestBlock && chainHeadBlock ? (
          <Space direction="horizontal">
            <Progress
              style={{ width: "10vw", minWidth: 80 }}
              strokeColor={{
                "0%": "#108ee9",
                "100%": "#87d068",
              }}
              status={indexingStatus.synced ? "success" : "active"}
              percent={
                indexingStatus.synced
                  ? 100
                  : Math.floor(
                      ((latestBlock - earliestBlock) / (chainHeadBlock - earliestBlock)) * 100,
                    )
              }
            />
            <Typography.Text
              style={{ color: textColor }}
            >{`Block sync ${latestBlock} / ${chainHeadBlock}`}</Typography.Text>
          </Space>
        ) : (
          "Initializing deployment..."
        )
      }
      headStyle={{
        backgroundColor: themeColor,
        color: textColor,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
      }}
    >
      {/* Status parts */}
      <Descriptions layout="vertical" colon={false} column={4}>
        {/* Subgraph status */}
        <Descriptions.Item label="Status" labelStyle={labelColor} span={1}>
          <Badge
            color={indexingStatus.health === "healthy" ? "green" : "red"}
            text={indexingStatus.health.charAt(0).toUpperCase() + indexingStatus.health.slice(1)}
          />
        </Descriptions.Item>

        {/* Network */}
        <Descriptions.Item label="Network" labelStyle={labelColor} span={1}>
          <Tag color={networkColor}>{chain?.network || "N/A"}</Tag>
        </Descriptions.Item>

        {/* Start block */}
        <Descriptions.Item label="Start block" labelStyle={labelColor} span={1}>
          <Typography>{earliestBlock || 'Please set "startBlock: 1" in subgraph.yaml'}</Typography>
        </Descriptions.Item>

        {/* Data count */}
        <Descriptions.Item label="Data count" labelStyle={labelColor} span={1}>
          <Typography>{indexingStatus.entityCount}</Typography>
        </Descriptions.Item>
      </Descriptions>

      {/* Error log */}
      {indexingStatus.fatalError ? (
        <>
          <Divider />
          <Alert
            message="Error"
            type="error"
            showIcon
            description={
              <Typography style={{ flex: 1, overflow: "auto", maxHeight: "15vh" }}>
                <Col>
                  <Row>
                    Block hash:
                    {indexingStatus.fatalError.block?.hash}
                  </Row>
                  <Row>
                    Block number:
                    {indexingStatus.fatalError.block?.number}
                  </Row>
                  <Row>{indexingStatus.fatalError?.message}</Row>
                </Col>
              </Typography>
            }
          />
        </>
      ) : null}
    </Card>
  );
}
